export default "__VITE_ASSET__be150867__"